import request from "@/utils/request"
const platform = localStorage.getItem('platform')

export function getCorporations(data) {
    return request.get(`/${platform}/corporations`, data)
}

export function deleteCorporations(ids) {
    ids = ids instanceof Array ? ids.join(',') : ids
    return request.delete(`/${platform}/corporations/${ids}`)
}

export function storeOrUpdateCorporation(data) {
    const method = data.id ? 'put' : 'post'
    const url = data.id ? `/${platform}/corporations/${data.id}` : `/${platform}/corporations`;
    return request[method](url, data)
}
